module.exports = __webpack_public_path__ + "img/DEE3E8_A6AEB5_BCC4CC_BCC4C4-256px.af16414b.png";